import type { ReactNode, SelectHTMLAttributes } from 'react';

import type { LookupOption } from '@/lib/api/schemas';

import { describedBy } from './a11y';
import { Field } from './field';

interface SelectFieldProps extends SelectHTMLAttributes<HTMLSelectElement> {
  id: string;
  label: ReactNode;
  options: readonly LookupOption[];
  placeholder?: string;
  error?: string | undefined;
  hint?: ReactNode;
  labelSize?: 'md' | 'lg';
  /** Option values rendered but not selectable (e.g. a state chosen in another row). */
  disabledValues?: ReadonlySet<string>;
}

export function SelectField({
  id,
  label,
  options,
  placeholder = 'Select...',
  error,
  hint,
  labelSize = 'md',
  disabledValues,
  className,
  ...select
}: SelectFieldProps) {
  return (
    <Field id={id} label={label} hint={hint} error={error} size={labelSize}>
      <select
        id={id}
        className={`select ${className ?? ''}`}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy(id, Boolean(hint), Boolean(error))}
        defaultValue={select.defaultValue ?? ''}
        {...select}
      >
        <option value="">{placeholder}</option>
        {options.map((o) => (
          <option key={o.value} value={o.value} disabled={disabledValues?.has(o.value)}>
            {o.label}
          </option>
        ))}
      </select>
    </Field>
  );
}
